export default () => ({
    expanded: false,

    state: {
        [':class']: 'expanded ? "--is-open" : ""',
        [':aria-expanded']: 'expanded',
    },

    toggle() {
        this.expanded = ! this.expanded
    },
})
